import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid, GridItem } from "@sainsburys-tech/fable";
import AlertFilter from "../AlertFilter";
import AlertList from "../AlertList";
import AlertSort from "../AlertSort";
import StoresDropdown from "../StoresDropdown";
import AlertSearch from "../AlertSearch";
import CloseButton from "../CloseButton";
import LoadingWrapper from "../LoadingWrapper";

class AlertsPage extends Component {
  state = {
    filter: {
      isVisible: true,
      isFullscreen: false
    },
    openChecked: {
      checked: false
    },
    investigatingChecked: {
      checked: false
    },
    closedChecked: {
      checked: false
    },
    storeId: this.props.storeId,
    searchText: "",
    showAlertIdNotFoundMessage: false
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    const filter = this.state.filter;
    if (filter.isFullscreen && !this.isMobile()) {
      filter.isFullscreen = false;
    }
    this.setState({ filter: filter });
  };

  handlePageChange = () => {
    this.props.pageAlerts();
  };

  handleError = response => {
    this.props.onError(response);
  };

  handleFilterCloseClick = () => {
    const filter = this.state.filter;
    filter.isVisible = false;
    filter.isFullscreen = false;

    this.setState({ filter: filter });
  };

  handleFiltersClick = () => {
    this.showFilter();
  };

  handleCheckboxChecked(name) {
    if (!this.props.status.includes(name)) {
      this.props.onStatusAdd(name);
    }
  }

  handleCheckboxUnchecked(name) {
    const i = this.props.status.indexOf(name);
    if (i !== -1) {
      this.props.onStatusRemove(i);
    }
  }

  handleSortOptionChange = e => {
    if (e.target.value === "") {
      return;
    }

    this.props.queryParams.sortBy = e.target.value;
    this.props.onSortOptionChange(e.target);
    this.applySort();
  };

  applySort = () => {
    this.props.clearPaging();
    this.clearSearch();
    this.props.loadAlerts();
  };

  handleFilterChange = e => {
    const name = e.target.name;
    const isChecked = e.target.checked;

    if (name === "Open") {
      this.setState({ openChecked: isChecked });
    }
    if (name === "Investigating") {
      this.setState({ investigatingChecked: isChecked });
    }
    if (name === "Closed") {
      this.setState({ closedChecked: isChecked });
    }

    isChecked
      ? this.handleCheckboxChecked(name)
      : this.handleCheckboxUnchecked(name);

    this.applyFilter(this.props.status);
  };

  showFilter() {
    const filter = this.state.filter;
    filter.isVisible = true;
    filter.isFullscreen = true;

    this.setState({ filter: filter });
  }

  applyFilter = (status, storeId) => {
    const filter = this.state.filter;

    this.props.clearPaging();
    this.clearSearch();

    filter.status = status;
    filter.storeId = storeId;

    this.setState({ filter: filter });

    this.props.loadAlerts();
  };

  handleStoreChanged = store => {
    const storeId = store ? store.value : "";
    const status = this.state.filter.status;

    this.props.onStoreIdChange(storeId);
    this.applyFilter(status, storeId);
  };

  isMobile = () => {
    if (window.innerWidth > 1200) {
      return false;
    }
    return true;
  };

  handleAlertSearchChange = text => {
    this.setState({ searchText: text });
  };

  handleAlertSearchClick = () => {
    if (!this.state.searchText) {
      this.clearSearch();
      this.props.loadAlerts();
      return;
    }

    this.props.searchAlerts(
      this.state.searchText,
      onAlertFound => {
        this.setState({ showAlertIdNotFoundMessage: false });
      },
      onAlertNotFound => {
        this.setState({ showAlertIdNotFoundMessage: true });
      }
    );
  };

  clearSearch() {
    this.setState({ searchText: "", showAlertIdNotFoundMessage: false });
  }

  render() {
    const filters = {
      alertStatuses: this.props.alertStatuses,
      filterStatus: this.props.status,
      onApplyFilter: this.handleApplyFilter,
      onFilterCloseClick: this.handleFilterCloseClick,
      isFullscreen: this.state.filter.isFullscreen,
      onFiltersClick: this.handleFiltersClick,
      onFilterChange: this.handleFilterChange
    };

    const sortOptions = {
      selectOptions: this.props.alertSortOptions,
      onSortOptionChange: this.handleSortOptionChange,
      selectedSortOptionCode: this.props.selectedSortOptionCode
    };

    const alerts = {
      items: this.props.pagedAlerts.items,
      isLoading: this.props.list.isLoading,
      isPaging: this.props.list.isPaging,
      onPageChange: this.handlePageChange,
      pagingEnabled: this.props.pagedAlerts.after !== null
    };

    return (
      <div style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
        <div style={{ width: "25%", minWidth: "240px", flexShrink: 0 }}>
          <div className="cb-c-alerts-page__left-panel alerts-page__filter">
            <div className="cb-c-alerts-page__options">
              <AlertSearch
                searchText={this.state.searchText}
                onChange={this.handleAlertSearchChange}
                onSearchClick={this.handleAlertSearchClick}
              />
              <AlertFilter
                alertStatuses={filters.alertStatuses}
                activeStatus={filters.filterStatus}
                onClick={filters.onApplyFilter}
                onFilterChange={filters.onFilterChange}
                disableCheckboxes={alerts.isLoading ? true : false}
              />
              <div style={{ marginTop: "1rem" }}>
                <StoresDropdown
                  handleStoreChanged={this.handleStoreChanged}
                  stores={this.props.stores}
                  storeId={this.state.storeId}
                />
              </div>
              <AlertSort
                selectOptions={sortOptions.selectOptions}
                onSortOptionChange={sortOptions.onSortOptionChange}
                selectedSortOptionCode={sortOptions.selectedSortOptionCode}
              />
            </div>
          </div>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <LoadingWrapper isLoading={alerts.isLoading}>
            <AlertList
              pagedAlerts={alerts.items}
              onPageChange={alerts.onPageChange}
              showFiltersButton={this.isMobile()}
              onFiltersClick={filters.onFiltersClick}
              redirectTo={this.props.queryParams}
              pagingEnabled={alerts.pagingEnabled}
              isPaging={alerts.isPaging}
              showAlertIdNotFoundMessage={this.state.showAlertIdNotFoundMessage}
            />
          </LoadingWrapper>
        </div>
      </div>
    );
  }
}

AlertsPage.propTypes = {
  sortOptions: PropTypes.object,
  pagedAlerts: PropTypes.object,
  list: PropTypes.object,
  alertStatuses: PropTypes.array,
  loadAlerts: PropTypes.func,
  pageAlerts: PropTypes.func,
  clearPaging: PropTypes.func,
  onStatusAdd: PropTypes.func,
  onStatusRemove: PropTypes.func,
  status: PropTypes.array,
  queryParams: PropTypes.object,
  searchAlerts: PropTypes.func
};

export default AlertsPage;
